module.exports = __webpack_public_path__ + "assets/logo-supervisor.png?f85e9cc0c220b43d06a82b86e8d018e4";